module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/lagoon/Room_lagoon_02slide_03.png";